"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/chooseSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ChooseSectionChooseThreesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Affordable Pricing" | "Hygiene & Sterilization" | "Flexible Scheduling" */
    h30Text: ReactNode;
    /** Detected variants: "Transparent, competitive pricing with flexible payment plans to fit every budget." | "Hospital-grade sterilization protocols and strict hygiene standards for your safety." | "Convenient appointment times, including evenings and weekends to your schedule." */
    p0Text: ReactNode;
    /** Detected variants: "choose-item-three" */
    className?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};

type ChooseSectionChooseThrees2Item = {
    key: Key | null | undefined;
    /** Detected variants: "choose-item-three" */
    className: string;
    /** Detected variants: "Painless Treatments" | "Certified Dentists" | "Modern Equipments" */
    h30Text: ReactNode;
    /** Detected variants: "Advanced anesthesia techniques and gentle procedures ensure pain free care." | "Our team of board-certified dentists brings decades of combined expertise." | "State-of-the-art technology and equipment for precise, efficient care." */
    p0Text: ReactNode;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeThreeChooseSectionGeneratedProps = {
    chooseSectionChooseThrees2DivH30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSectionChooseThrees2Item) => Partial<ComponentProps<"h3">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSectionChooseThreesItem) => Partial<ComponentProps<"h3">>);
    /** Default: "fade-up" */
    sectionDiv0Div0DivDataAos?: string;
    /** Default: "Why Choose Us" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Why Choose Our Dental Service?" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Experience the difference that quality care, modern technology, and genuine compassion make." */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "choose-img" */
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose-img-1.png" */
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-img" */
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose-img-2.png" */
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-img" */
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose-img-3.png" */
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageSrc?: string;
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-img" */
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/choose-bg-3.png" */
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageSrc?: string;
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-bg-1" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/choose-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-bg-2" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/choose-bg-02.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-bg-1" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/choose-bg-1.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-bg-2" */
    sectionImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/choose-bg-2.png" */
    sectionImageWithBasePath3ImageSrc?: string;
    sectionImageWithBasePath3ImageVisible?: boolean;
    sectionImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    chooseSectionChooseThrees: ChooseSectionChooseThreesItem[];
    chooseSectionChooseThrees2: ChooseSectionChooseThrees2Item[];
    chooseSectionChooseThreesItemWrapper?: (item: ChooseSectionChooseThreesItem, content: ReactNode) => ReactNode;
    chooseSectionChooseThreesRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseSectionChooseThreesH3Visible?: boolean;
    chooseSectionChooseThreesH3Renderer?: (item: ChooseSectionChooseThreesItem, defaultNode: ReactNode) => ReactNode;
    chooseSectionChooseThreesH3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSectionChooseThreesItem) => Partial<ComponentProps<"h3">>);
    chooseSectionChooseThrees2ItemWrapper?: (item: ChooseSectionChooseThrees2Item, content: ReactNode) => ReactNode;
    chooseSectionChooseThrees2Renderer?: (defaultNode: ReactNode) => ReactNode;
    chooseSectionChooseThrees2H3Visible?: boolean;
    chooseSectionChooseThrees2H3Renderer?: (item: ChooseSectionChooseThrees2Item, defaultNode: ReactNode) => ReactNode;
    chooseSectionChooseThrees2H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSectionChooseThrees2Item) => Partial<ComponentProps<"h3">>);
};

const HomeThreeChooseSectionGenerated: FC<HomeThreeChooseSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Why Choose Us",
    sectionDiv0Div0DivDataAos = "fade-up",
    sectionDiv0Div0H20H2Text = "Why Choose Our Dental Service?",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "Experience the difference that quality care, modern technology, and genuine compassion make.",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt = "choose-img",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/choose-img-1.png",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageAlt = "choose-img",
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/about/choose-img-2.png",
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageAlt = "choose-img",
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/about/choose-img-3.png",
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageVisible,
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageRenderer,
    sectionDiv0Div1Div1Div0ImageWithBasePath2ImageProps,
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageAlt = "choose-img",
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/choose-bg-3.png",
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageVisible,
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageRenderer,
    sectionDiv0Div1Div1Div0ImageWithBasePath3ImageProps,
    sectionImageWithBasePath0ImageAlt = "choose-bg-1",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/category/choose-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "choose-bg-2",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/category/choose-bg-02.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "choose-bg-1",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/choose-bg-1.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionImageWithBasePath3ImageAlt = "choose-bg-2",
    sectionImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/choose-bg-2.png",
    sectionImageWithBasePath3ImageVisible,
    sectionImageWithBasePath3ImageRenderer,
    sectionImageWithBasePath3ImageProps,
    chooseSectionChooseThrees2DivH30H3Props,
    divH30H3Props,
    sectionDiv0Div1ClassName,
    chooseSectionChooseThrees,
    chooseSectionChooseThrees2,
    chooseSectionChooseThreesItemWrapper,
    chooseSectionChooseThreesRenderer,
    chooseSectionChooseThreesH3Visible,
    chooseSectionChooseThreesH3Renderer,
    chooseSectionChooseThreesH3Props,
    chooseSectionChooseThrees2ItemWrapper,
    chooseSectionChooseThrees2Renderer,
    chooseSectionChooseThrees2H3Visible,
    chooseSectionChooseThrees2H3Renderer,
    chooseSectionChooseThrees2H3Props,
}) => {
    return (
        <section className="whychoose-section whychoose-section-three section">
            <div className="container">
                <div className="section-header section-header-three text-center aos" data-aos={sectionDiv0Div0DivDataAos}>
                    <div className="title">
                        <i className="fa-solid fa-circle" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="subtitle">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row align-items-center"}>
                    <div className="col-xl-3 left">
                        {renderCollectionNode(
                            chooseSectionChooseThrees,
                            (item: ChooseSectionChooseThreesItem) => (
                                <div className={item.className ?? "choose-item-three"} key={item.key}>
                                    {renderItemNode(chooseSectionChooseThreesH3Visible, chooseSectionChooseThreesH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof chooseSectionChooseThreesH3Props === "function" ? chooseSectionChooseThreesH3Props(item) : (chooseSectionChooseThreesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <p>{item.p0Text}</p>
                                </div>
                            ),
                            chooseSectionChooseThreesItemWrapper,
                            chooseSectionChooseThreesRenderer
                        )}
                    </div>
                    <div className="col-xl-6">
                        <div className="choose-img">
                            {renderNode(sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div1Div1Div0ImageWithBasePath1ImageVisible, sectionDiv0Div1Div1Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div1Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div1Div1Div0ImageWithBasePath1ImageAlt} className="img-fluid img-2" {...(sectionDiv0Div1Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div1Div1Div0ImageWithBasePath2ImageVisible, sectionDiv0Div1Div1Div0ImageWithBasePath2ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div1Div0ImageWithBasePath2ImageSrc} alt={sectionDiv0Div1Div1Div0ImageWithBasePath2ImageAlt} className="img-fluid img-3" {...(sectionDiv0Div1Div1Div0ImageWithBasePath2ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div1Div1Div0ImageWithBasePath3ImageVisible, sectionDiv0Div1Div1Div0ImageWithBasePath3ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div1Div0ImageWithBasePath3ImageSrc} alt={sectionDiv0Div1Div1Div0ImageWithBasePath3ImageAlt} className="img-fluid img-4" {...(sectionDiv0Div1Div1Div0ImageWithBasePath3ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-xl-3 right">
                        {renderCollectionNode(
                            chooseSectionChooseThrees2,
                            (item: ChooseSectionChooseThrees2Item) => (
                                <div className={item.className} key={item.key}>
                                    {renderItemNode(chooseSectionChooseThrees2H3Visible, chooseSectionChooseThrees2H3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof chooseSectionChooseThrees2H3Props === "function" ? chooseSectionChooseThrees2H3Props(item) : (chooseSectionChooseThrees2H3Props ?? {}))} {...(typeof chooseSectionChooseThrees2DivH30H3Props === "function" ? chooseSectionChooseThrees2DivH30H3Props(item) : (chooseSectionChooseThrees2DivH30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <p>{item.p0Text}</p>
                                </div>
                            ),
                            chooseSectionChooseThrees2ItemWrapper,
                            chooseSectionChooseThrees2Renderer
                        )}
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-3" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-4" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath3ImageVisible, sectionImageWithBasePath3ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath3ImageSrc} alt={sectionImageWithBasePath3ImageAlt} className="img-fluid element-2" {...(sectionImageWithBasePath3ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeThreeChooseSectionGenerated;
